import React from "react";
import { useHistory } from "react-router-dom";
import Hours from "../../Media/24-hours.png";
import Bike from "../../Media/mountain-bike.png";

const HomeInfo = () => {
  const history = useHistory();
  return (
    <section>
      <div className="container p-lg-0">
        <div className="row">
          <div className="col-sm-12">
            <div className="row basic_text p-3">
              <div className="my-2 pr-3">
                <img src={Hours} alt="" />{" "}
                <span className="basic_content">24/7 Doctor Available</span>
              </div>
              <div className="my-2">
                <span style={{ fontWeight: "bold" }}>Medicine Delivery:</span>{" "}
                <span>
                  <img
                    style={{ height: "31px", width: "31px" }}
                    src={Bike}
                    alt=""
                  />{" "}
                  <span className="basic_content">Express 60 Mins</span>
                </span>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <button onClick={() => history.push("/doctor")}>doctor video</button> */}
    </section>
  );
};

export default HomeInfo;
